export const name = 'rnSearch';
/**
 * @ngdoc service
 * @name rhino.components.search.service:rnSearch
 * @description This service provides the client application with the ability to query the CSIS Genesis search server.
 */
export default function rnSearch($log, $q, rnHttp) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var self = this;

  /**
   * This is the externally facing API of the service
   */
  var service = {
    search: search
  };

  return service;


  /////////////////////
  // Private functions
  ////////////////////

  function search(params) {

    var url = constructUrl(params);
    var query = constructQuery(params);

    return doPost(url, query);
  }

  function constructUrl() {
    var url = '/apps/search/';
    return url;
  }

  /**
   * Constructs an Elastic Search query based upon the search terms
   * @param params
   * @returns {{query: {match: {_all: *}}}}
   */
  function constructQuery(params) {

    var searchTerm = params.searchFor;
    var q = {};
    getQuery(q, searchTerm);

    return q;
  }

  function attachSearchTerm(q, searchTerm) {
    q.searchFor = searchTerm;
  }

  function detachSearchTerm(q) {
    delete q.searchFor;
  }

  function getQuery(q, searchTerm) {
    attachSearchTerm(q, searchTerm);
    q.query = {};
    getQueryType(q);
    detachSearchTerm(q);
  }

  function getQueryType(q) {
    var isPhraseSearch = (q.searchFor.indexOf('"') === 0) && (q.searchFor.lastIndexOf('"') === q.searchFor.length - 1);
    var queryType = isPhraseSearch ? "match_phrase" : "match";
    q.query[queryType] = {"_all": q.searchFor};
  }

  function doPost(path, content) {
    var service = 'portal_service';
    return rnHttp.post(service, path, content);
  }
}
